import {AgentHome, LLPHome} from './home/home';
import {BaseResponse} from './internal/baseresponse';

export class HomeResult extends BaseResponse {
  data: AgentHome;
}

export class LLPHomeResult extends BaseResponse {
  data: LLPHome;
}



// WEBPACK FOOTER //
// ./src/app/response/homeresult.ts